import { render } from "./Download-App.vue?vue&type=template&id=7dcc4836&scoped=true"
import script from "./Download-App.vue?vue&type=script&lang=js"
export * from "./Download-App.vue?vue&type=script&lang=js"

import "./Download-App.vue?vue&type=style&index=0&id=7dcc4836&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4071947400/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcc4836"]])

export default __exports__